module.exports = __webpack_public_path__ + "img/768x325.bc84581e.png";